

export class UnderSectionGroupDto implements IUnderSectionGroupDto {
    id!: number | undefined;
    groupName!: string | undefined;
    fromAmount!: number;
    toAmount!: number;
    maxAllowAmount!: number;
    shortCode!: string | undefined;

    constructor(data?: IUnderSectionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupName = _data["groupName"];
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
            this.maxAllowAmount = _data["maxAllowAmount"];
            this.shortCode = _data["shortCode"];
        }
    }

    static fromJS(data: any): UnderSectionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnderSectionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupName"] = this.groupName;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        data["maxAllowAmount"] = this.maxAllowAmount;
        data["shortCode"] = this.shortCode;
        return data; 
    }
}

export interface IUnderSectionGroupDto {
    id: number | undefined;
    groupName: string | undefined;
    fromAmount: number;
    toAmount: number;
    maxAllowAmount: number;
    shortCode: string | undefined;
}

